import { ButtonFilterInputText, ButtonFilterOptions } from '@/components/custom';
import { usePaymentMethodRequests, useUrlParams } from '../hooks';
import { PaymentMethodRequestStatusEnum } from '@/enums';
import { getSelectOptions } from '@/functions';
import { ISelectOption } from '@/interfaces';
import { TNullable } from '@/types';

const Filters = () => {

  const { isLoading } = usePaymentMethodRequests();
  const { status, country, setFilters } = useUrlParams();

  const handleOnChangeCountry = (value?: TNullable<string>) =>
    setFilters({ country: value || null });

  const handleOnChangeStatus = (options: ISelectOption[]) =>
    setFilters({ status: (options[0]?.value as PaymentMethodRequestStatusEnum) ?? null });

  return (
    <div className='flex flex-wrap gap-2'>
      <ButtonFilterInputText
        disabled={isLoading}
        value={country}
        inputPlaceholder={`Pays`}
        onChange={handleOnChangeCountry}
        text='Pays' />
      <ButtonFilterOptions
        disabled={isLoading}
        options={getSelectOptions('PaymentMethodRequestStatusEnum')}
        onChange={handleOnChangeStatus}
        value={status ? [status] : []}
        text='Statut' />
    </div>
  );

};

export default Filters;
